import React, { useState } from "react";

const PersonalCard = ({ names, occupations }) => {
  const handleOnChange = (e, funcSet) => {
    e.preventDefault();
    funcSet(e.target.value);
  };
  return (
    <div className="flex flex-col px-5 pt-5 pb-52 md:py-5 gap-5 w-full overflow-y-auto">
      <div className="flex flex-col gap-2">
        <div className="font-bold">Name</div>
        <div className="flex flex-col w-full gap-3">
          {names.map((val, ind) => (
            <div key={ind} className="flex flex-row w-full items-center">
              <div className="flex flex-row w-1/3 justify-start items-center gap-3">
                <div>
                  {val.label.includes("*")
                    ? val.label.slice(0, val.label.length - 1)
                    : val.label}
                </div>
                {val.label.includes("*") ? (
                  <div
                    className="tooltip bg-gray-200 rounded-full h-[20px] w-[20px] text-[9px] flex justify-center items-center hover:bg-gray-300"
                    data-tip={"This field is required."}
                  >
                    i
                  </div>
                ) : null}
              </div>
              <input
                className="flex flex-col border border-black rounded-lg w-6/12 h-[40px] px-3"
                onChange={(e) => handleOnChange(e, val.funcSet)}
                value={val.value}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="font-bold">Occupation</div>
        <div className="flex flex-col w-full gap-3">
          {occupations.map((val, ind) => (
            <div key={ind} className="flex flex-row w-full items-center">
              <div className="flex flex-row w-1/3 justify-start items-center gap-3">
                <div>
                  {val.label.includes("*")
                    ? val.label.slice(0, val.label.length - 1)
                    : val.label}
                </div>
                {val.label.includes("*") ? (
                  <div
                    className="tooltip bg-gray-200 rounded-full h-[20px] w-[20px] text-[9px] flex justify-center items-center hover:bg-gray-300"
                    data-tip={"This field is required."}
                  >
                    i
                  </div>
                ) : null}
              </div>
              {val.label.toLowerCase() == "about me" ? (
                <textarea
                  className="flex flex-col border border-black rounded-lg w-6/12 px-3 py-1"
                  onChange={(e) => handleOnChange(e, val.funcSet)}
                  value={val.value}
                  rows={3}
                />
              ) : (
                <input
                  className="flex flex-col border border-black rounded-lg w-6/12 h-[40px] px-3"
                  onChange={(e) => handleOnChange(e, val.funcSet)}
                  value={val.value}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PersonalCard;
